// userSlice.ts or userActions.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { SendRequestCallback, Device } from "../../types";
import { showError } from "../notifications";

export const fetchDevices = createAsyncThunk<
  { data: Device[], count: number },
  SendRequestCallback<any, { data: { data: Device[], count: number } }, any>
>("devices/fetchDevices", async (sendRequest, { dispatch }) => {
  try {
    const response: any = await sendRequest("get")({
      url: `/org/devices`,
    });
    return response.data;
  } catch (err) {
    dispatch(showError("Failed to fetch Devices"));
    console.log(err);
  }
});
